/**
 * Публичный экспорт модуля «Корпоративная почта»
 */
export { CorporateMail, default } from './CorporateMail';
export * from './types';
export * from './constants';
export * from './api';
export * from './utils';
